'use client'

import { useEffect, useState } from 'react'

/**
 * Хук для определения, что компонент смонтирован на клиенте
 * Полезен для предотвращения ошибок гидратации
 */
export const useIsClient = (): boolean => {
	const [isClient, setIsClient] = useState(false)

	useEffect(() => {
		setIsClient(true)
	}, [])

	return isClient
}
